<template>
    <div class="logo-links">
        <a class="logo-link" v-for="(link, index) in logoLinks"  :key="'link-' + index">
            <img v-if="link.image" :src="link.image" :alt="link.alt">
        </a>
    </div>
</template>

<script>
export default {
    name: 'logo-links',
    data() {
        return {
            logoLinks: [],
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.fetchLogoLinks();
        },
        fetchLogoLinks() {
            // TODO: Fetch from API call.
            this.logoLinks = [
            ];
        },
    }
}
</script>
